var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('v-breadcrumbs',{attrs:{"items":_vm.routesBack},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}])}),_c('AppBody',{attrs:{"subtitle":_vm.titleModal}},[(_vm.getComboType === 'edit')?_c('editComboForm'):_c('comboForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }